import { get, put } from '@aiptyg/api-client';
import type { LegalDocumentDTO, LegalDocumentSummaryDTO } from '../types/legal.types';

interface LegalDocumentListResponse {
  items: LegalDocumentSummaryDTO[];
}

export function listPublicLegalDocuments(marketId = 'CN'): Promise<LegalDocumentListResponse> {
  return get<LegalDocumentListResponse>(
    `/v1/public/legal-documents?market_id=${encodeURIComponent(marketId)}`,
  );
}

export function getPublicLegalDocument(slug: string, marketId = 'CN'): Promise<LegalDocumentDTO> {
  return get<LegalDocumentDTO>(
    `/v1/public/legal-documents/${slug}?market_id=${encodeURIComponent(marketId)}`,
  );
}

export function updateLegalDocument(slug: string, data: {
  marketId: string;
  title: string;
  summary: string;
  effectiveDate: string;
  contentMarkdown: string;
}): Promise<{ documents: unknown[] }> {
  return put<{ documents: unknown[] }>(`/v1/admin/settings/legal-documents/${slug}`, {
    market_id: data.marketId,
    title: data.title,
    summary: data.summary,
    effective_date: data.effectiveDate,
    content_markdown: data.contentMarkdown,
  });
}
